import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Classification } from '@portal-shared/app/entities/class.model';
import { HttpCacheService } from '@portal-shared/app/services/http-cache.service';
import { LoadingService } from '@portal-shared/app/services/loading.service';
import { AssignmentHelper } from '@shared/helpers/assignment.helper';
import { AssignmentDto } from './dtos/assignment.dto';
import { CreateAssignmentDto } from './dtos/create-assignment.dto';
import { ReassignAssignmentDto } from './dtos/reassign-assignment.dto';
import { ShiftAssignmentDto } from './dtos/shift-assignment.dto';
import { AllyaNotificationClient } from './notifications/allya-notification-client';
import { ReassignAssignmentNotificationDto } from './notifications/models/reassign-assignment-notification.dto';
import { ShiftAssignmentNotificationDto } from './notifications/models/shift-assignment-notification.dto';

@Injectable({
  providedIn: 'root'
})
export class AssignmentService extends HttpCacheService {
  public constructor(
    httpClient: HttpClient,
    private notificationClient: AllyaNotificationClient,
    private loadingService: LoadingService
  ) {
    super(httpClient, '/api/assignments');
  }

  public async createAssignment(createAssignmentDto: CreateAssignmentDto) {
    const assignment = await this.command()
      .withBody(createAssignmentDto)
      .withLoading(this.loadingService)
      .postEntity<AssignmentDto>(a => ({ ...a, classId: Classification.handleUndefinedClass(a.classId) }));
    this.notificationClient.sendAssignmentCreated(assignment);
  }

  public async reAssignAssignment(
    assignmentDto: AssignmentDto,
    toResourceId: string | undefined,
    allowMerge: boolean = false
  ) {
    if (!toResourceId || toResourceId === assignmentDto.resourceId || AssignmentHelper.isNewAssignment(assignmentDto)) {
      return;
    }

    const dto: ReassignAssignmentDto = {
      assignmentId: assignmentDto.id,
      resourceId: toResourceId,
      allowMerge
    };

    const result = await this.command('re-assign')
      .withBody(dto)
      .withLoading(this.loadingService)
      .post<ReassignAssignmentNotificationDto>();
    this.notificationClient.sendReassignAssignment(result);
  }

  public async shiftAssignment(assignment: AssignmentDto, startingPeriod: number, numberOfPeriods = 1) {
    const dto: ShiftAssignmentDto = {
      assignmentId: assignment.id,
      startingPeriod,
      numberOfPeriods
    };

    const result = await this.command('shift')
      .withBody(dto)
      .withLoading(this.loadingService)
      .post<ShiftAssignmentNotificationDto>();
    this.notificationClient.sendShiftAssignment(result);
  }
}
